var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBellLight = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#22262A",
    d: "M4.839 6.727a4.19 4.19 0 0 1 8.328 0l.188 1.7.005.043a6 6 0 0 0 .805 2.384l.022.037.434.723c.393.655.59.983.547 1.252a.75.75 0 0 1-.26.458c-.208.175-.59.175-1.355.175H4.452c-.765 0-1.147 0-1.356-.175a.75.75 0 0 1-.26-.458c-.042-.269.155-.597.548-1.252l.434-.723.022-.037a6 6 0 0 0 .805-2.384l.005-.044z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#22262A",
    strokeLinecap: "round",
    d: "M6.829 13.803c.128.558.41 1.05.804 1.403a2.05 2.05 0 0 0 1.37.542c.494 0 .976-.19 1.369-.542s.675-.845.803-1.403"
  })));
};
export default SvgBellLight;